import {JSEncrypt} from 'jsencrypt'

export const encryptByRSA = (str) => {
    let encrypt = new JSEncrypt();
    let public_key = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQYTfsxrqPxJ/biBeDpQD39ZnfTXFzgU0KSnjFYT6b1g7Qnera9nsEAkpp6N0r6hmE+Dvo47ifesQW8t4VG6ZHsYHgAk8Z4U8oWBrkxyOWnedLAHLTRL/WFFYHU01+WcyS7ZkeD+a5JndSlw360Zh4zA0FzdJidejs62eLKJSogQIDAQAB";
    encrypt.setPublicKey(public_key);
    return encrypt.encrypt(str);
};
